const permit = (actions: string[], permissions: string[]) => {
  const permitted = actions.some((p) => permissions?.includes(p));
  if (!permitted) {
    return false;
  }
  return true;
};
export default permit;
